import React          from 'react';
import Background     from "../../Media/ProcessesBG.webp"
import ProcessesImage from "../../Media/Processes.png"
import "./Processes.css";

const Processes = () =>{
    return (
        <div className = "processes"  style = {{backgroundImage:    `url(${Background})`,
                                                backgroundRepeat:   "no-repeat",
                                                backgroundSize:     "100vw",
                                                backgroundPosition: "top center",
                                                backgroundColor:    "var(--green)"}}>
            <h2>Başvuru Süreci</h2>

            <div className = "processesFade"></div>
            <img className = "noSelect" src = {ProcessesImage} alt = ""/>

            <div className = "whoCanJoin">
                <h2>Kimler Başvurabilir</h2>
                <ul>
                    <li>Dijital Dönüşüm ve Blockchain alanlarında kariyer hedefleyen,                           </li>
                    <li>Üniversitelerin Bilgisayar ve Yazılım başta olmak üzere Mühendislik bölümlerinde okuyan,</li>
                    <li>3. sınıf, 4. sınıf, yeni mezun veya yüksek lisans öğrencileri                           </li>
                </ul>
            </div>
        </div>
    )
}

export default Processes;